document.addEventListener('DOMContentLoaded', () => {
  const root = document.querySelector('.exit-intent-popup--c');
  if (!root) return;


  const enabled = root.dataset.enabled === 'true';
  if (!enabled) return;

  const modal = root.querySelector('.exit-intent-popup--c__modal');
  const closeBtn = root.querySelector('.exit-intent-popup--c__close');
  const ctaBtn = root.querySelector('.exit-intent-popup--c__cta');
  const overlay = root.querySelector('.exit-intent-popup--c__overlay');

  const STORAGE_KEY = 'cvf_exit_popup_shown';
  const COOKIE_DURATION = 7 * 24 * 60 * 60 * 1000;
  
  let hasShown = false;
  let canShow = false;
  let lastScrollY = window.scrollY;
  let scrollUpDistance = 0;

  const delay = (root.dataset.delay ? parseInt(root.dataset.delay, 10) : 3) * 1000;
  const frequency = root.dataset.frequency || '7days';

  const hasSeenPopup = () => {
    // Always show if frequency is set to 'always'
    if (frequency === 'always') return false;
    
    try {
      // Check sessionStorage for 'session' frequency
      if (frequency === 'session') {
        return sessionStorage.getItem(STORAGE_KEY) !== null;
      }
      
      // Check localStorage with timestamp for '7days' frequency
      if (frequency === '7days') {
        const stored = localStorage.getItem(STORAGE_KEY);
        if (stored) {
          const timestamp = parseInt(stored, 10);
          if (Date.now() - timestamp < COOKIE_DURATION) {
            return true;
          }
          localStorage.removeItem(STORAGE_KEY);
        }
      }
    } catch (e) {
      // Storage not available
    }
    return false;
  };

  const markAsShown = () => {
    // Don't store anything if frequency is 'always'
    if (frequency === 'always') return;
    
    try {
      if (frequency === 'session') {
        sessionStorage.setItem(STORAGE_KEY, 'true');
      } else if (frequency === '7days') {
        localStorage.setItem(STORAGE_KEY, Date.now().toString());
      }
    } catch (e) {
      // Storage not available
    }
  };

  const showPopup = () => {
    if (hasShown || hasSeenPopup()) return;
    
    // Check if body has the variant C class from Convert Experiments
    if (!document.body.classList.contains('pf-variant-c')) return;
    
    hasShown = true;
    
    root.style.display = '';
    root.classList.add('active');
    document.body.style.overflow = 'hidden';
    
    markAsShown();
  };

  const hidePopup = () => {
    root.classList.remove('active');
    document.body.style.overflow = '';
  };

  setTimeout(() => {
    canShow = true;
  }, delay);

  const handleMouseLeave = (e) => {
    if (!canShow || hasShown) return;
    
    if (e.clientY <= 0) {
      showPopup();
    }
  };

  const handleScroll = () => {
    if (!canShow || hasShown) return;

    const currentScrollY = window.scrollY;
    
    if (currentScrollY < lastScrollY && currentScrollY <= 100) {
      scrollUpDistance += lastScrollY - currentScrollY;
      
      if (scrollUpDistance > 50) {
        showPopup();
      }
    } else {
      scrollUpDistance = 0;
    }
    
    lastScrollY = currentScrollY;
  };

  const isMobile = () => {
    const hasTouchScreen = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);
    const isSmallScreen = window.innerWidth < 768;
    return hasTouchScreen && isSmallScreen;
  };

  const setupListeners = () => {
    const mobile = isMobile();
    
    if (mobile) {
      window.addEventListener('scroll', handleScroll, { passive: true });
    } else {
      document.addEventListener('mouseleave', handleMouseLeave);
    }
  };

  if (!hasSeenPopup()) {
    setupListeners();
  }

  closeBtn.addEventListener('click', hidePopup);
  overlay.addEventListener('click', hidePopup);
  
  ctaBtn.addEventListener('click', hidePopup);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && root.classList.contains('active')) {
      hidePopup();
    }
  });
});
